import { FinancialDocumentExtended } from "@common/types/financialDocument";
import { FinancialDocumentPreview } from "@components/documents/FinancialDocumentDetails/FinancialDocumentPreview";
import { Drawer } from "@design-system/Drawer/Drawer";

const NO_RETRY = { retry: false };

interface Props {
    financialDocument: FinancialDocumentExtended | null;
    onClose: () => void;
}

export const AccrualImporterQuickLook: React.FC<Props> = ({
    financialDocument,
    onClose,
}) => (
    <Drawer
        open={financialDocument !== null}
        onClose={onClose}
        direction="right"
        size="half"
        noPadding
        noScroll
    >
        {financialDocument && (
            <FinancialDocumentPreview
                financialDocument={financialDocument}
                className="h-100"
                noPadding
                queryOptions={NO_RETRY}
            />
        )}
    </Drawer>
);
